// extracted by mini-css-extract-plugin
export default {"content":"style_content__LCO80","itemName":"style_itemName__Mii10"};